var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFour(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 39.5,
    cy: 39.5,
    r: 34,
    stroke: "#314064",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.5 68C55.2401 68 68 55.2401 68 39.5C68 23.7599 55.2401 11 39.5 11C23.7599 11 11 23.7599 11 39.5",
    stroke: "#FAFDFF",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0001 40.0001L36.0565 43.9053C32.1598 47.7641 30.2115 49.6935 30.757 51.3581C30.8038 51.5012 30.8621 51.6404 30.9311 51.7744C31.734 53.3334 34.4894 53.3334 40.0001 53.3334C45.5108 53.3334 48.2661 53.3334 49.0691 51.7744C49.1381 51.6404 49.1963 51.5012 49.2432 51.3581C49.7887 49.6935 47.8403 47.7641 43.9437 43.9053L40.0001 40.0001ZM40.0001 40.0001L43.9437 36.0948C47.8403 32.2361 49.7887 30.3067 49.2432 28.6421C49.1963 28.499 49.1381 28.3598 49.0691 28.2258C48.2661 26.6667 45.5108 26.6667 40.0001 26.6667C34.4894 26.6667 31.734 26.6667 30.9311 28.2258C30.8621 28.3598 30.8038 28.499 30.757 28.6421C30.2115 30.3067 32.1598 32.2361 36.0565 36.0948L40.0001 40.0001Z",
    stroke: "#314064",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFour);
export default __webpack_public_path__ + "static/media/four.7ce33d6476a0fabf85adad454533d165.svg";
export { ForwardRef as ReactComponent };